<template>
  <b-modal
    id="ModId5"
    ref="modal"
    hide-footer
    title="Биллинг"
    size="lg"
    :no-close-on-backdrop=true
    @cancel="clearModal"
    @hidden="clearModal"
    :ok-disabled="veeErrors.any()"
  >
    <b-container fluid v-if="!loading">
      <div class="modal-spinner">
        <b-spinner variant="secondary" label="Loading..."></b-spinner>
        <strong class="mt-3">Загрузка...</strong>
      </div>
    </b-container>
    <b-container fluid v-else>
      <b-form ref="form" @submit.stop.prevent="onSubmit" v-if="billingDropdowns.custom_subscription">
        <b-container fluid>
          <h4>Тариф</h4>
          <b-row class="pb-3">
            <b-col md="3" class="pl-0">
              <b-form-group
                label="Тариф *"
                label-for="type_id"
                label-class="mf-label"
              >
                <treeselect id="type_id"
                            :options="selectsTariff"
                            v-model="modelCustom.p_type_id"
                            placeholder="Выбрать..."
                            noResultsText="Ничего не найдено..."
                            :clearable=true
                >
                  <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}</div>
                </treeselect>
                <b-form-invalid-feedback id="type-id-feedback">
                  Введите ОПФ.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="Начало действия *"
                label-for="begin"
                label-class="mf-label"
              >
                <VueCtkDateTimePicker
                  id="begin"
                  v-model="modelCustom.p_start_at"
                  color="#40b539"
                  label="Начало действия"
                  button-now-translation="Сегодня"
                  locale="ru"
                  onlyDate
                  :custom-shortcuts="customShortcuts"
                  format="YYYY-MM-DD HH:mm"
                  formatted="ll"
                >
                </VueCtkDateTimePicker>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="перманетный"
                            label-class="mf-label"
                            label-for="permanent"
              >
                <b-form-checkbox id="permanent"
                                 v-model="modelCustom.p_permanent"
                                 type="checkbox"
                                 class="ml-4"
                >
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="pb-3">
            <b-col md="3" class="pl-0">
              <b-form-group label="индивидуальный"
                            label-class="mf-label"
                            label-for="individual"
              >
                <b-form-checkbox id="individual"
                                 v-model="modelCustom.p_custom"
                                 type="checkbox"
                                 class="ml-4"
                >
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                :label="isIndividualTariff.p_client_price.label"
                label-for="client-price-input"
                label-class="mf-label"
                :invalid-feedback="getError('client-price-input')"
              >
                <b-form-input
                  id="client-price-input"
                  name="client-price-input"
                  v-validate="isIndividualTariff.p_client_price.validation"
                  v-model="modelCustom.p_client_price"
                  :state="validateState('client-price-input')"
                  :disabled="isIndividualTariff.p_client_price.disabled"
                ></b-form-input>

              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                :label="isIndividualTariff.p_ctm_price.label"
                label-for="org-price-input"
                label-class="mf-label"
                :invalid-feedback="getError('org-price-input')"
              >
                <b-form-input
                  id="org-price-input"
                  name="org-price-input"
                  v-validate="isIndividualTariff.p_ctm_price.validation"
                  v-model="modelCustom.p_ctm_price"
                  :state="validateState('org-price-input')"
                  :disabled="isIndividualTariff.p_ctm_price.disabled"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3" class="pr-0 button_place">
              <b-button class="tariff-button" @click="sendCustomSubscriptionData">Добавить</b-button>
            </b-col>
          </b-row>
          <hr class="my-1">
        </b-container>
      </b-form>
      <b-form ref="form" @submit.stop.prevent="onSubmit" v-if="billingDropdowns.service_unlim">

        <b-container fluid>
          <h4>Опция</h4>
          <b-row class="pb-3">
            <b-col md="3" class="pl-0">
              <b-form-group
                label="Тип пакетов *"
                label-for="service-id"
                label-class="mf-label"
              >
                <treeselect id="service-id"
                            :options="selectsOptions"
                            v-model="modelServiceUnlim.p_service_id"
                            placeholder="Выбрать..."
                            noResultsText="Ничего не найдено..."
                            :clearable=true
                >
                  <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}</div>
                </treeselect>
                <b-form-invalid-feedback id="opf-feedback">
                  Введите ОПФ.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">

              <b-form-group
                label="Начало действия *"
                label-for="begin-custom"
                label-class="mf-label"
              >
                <VueCtkDateTimePicker
                  id="begin-custom"
                  v-model="modelServiceUnlim.p_start_at"
                  color="#40b539"
                  locale="ru"
                  button-now-translation="Сегодня"
                  label="Начало действия"
                  onlyDate
                  :custom-shortcuts="customShortcuts"
                  format="YYYY-MM-DD HH:mm"
                  formatted="ll"
                >
                </VueCtkDateTimePicker>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="pb-3">
            <b-col md="3" class="pl-0">
              <b-form-group label="индивидуальный"
                            label-class="mf-label"
                            label-for="individual-options"
              >
                <b-form-checkbox id="individual-options"
                                 v-model="modelServiceUnlim.p_custom"
                                 type="checkbox"
                                 class="ml-4"
                >
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                :label="isIndividualService.p_client_price.label"
                label-for="client-input"
                label-class="mf-label"
                :invalid-feedback="getError('client-input')"
              >
                <b-form-input
                  id="client-input"
                  name="client-input"
                  v-validate="isIndividualService.p_client_price.validation"
                  v-model="modelServiceUnlim.p_client_price"
                  :state="validateState('client-input')"
                  :disabled="isIndividualService.p_client_price.disabled"
                ></b-form-input>

              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                :label="isIndividualService.p_ctm_price.label"
                label-for="org-input"
                label-class="mf-label"
                :invalid-feedback="getError('org-input')"
              >
                <b-form-input
                  id="org-input"
                  name="org-input"
                  v-validate="isIndividualService.p_ctm_price.validation"
                  v-model="modelServiceUnlim.p_ctm_price"
                  :state="validateState('org-input')"
                  :disabled="isIndividualService.p_ctm_price.disabled"
                ></b-form-input>

              </b-form-group>
            </b-col>
            <b-col md="3" class="pr-0 button_place">
              <b-button class="tariff-button" @click="sendServiceUnlimData">Добавить</b-button>
            </b-col>
          </b-row>
          <hr class="my-1">
        </b-container>
      </b-form>
      <b-form ref="form" @submit.stop.prevent="onSubmit" v-if="billingDropdowns.full_unlim">
        <h4>Полный безлимит</h4>
        <b-row class="pb-3">
          <b-col md="3">
            <b-form-group
              label="Начало действия *"
              label-for="begin-full-unlim"
              label-class="mf-label"
            >
              <VueCtkDateTimePicker
                id="begin-full-unlim"
                v-model="modelFullUnlim.p_start_at"
                label="Начало действия"
                button-now-translation="Сегодня"
                color="#40b539"
                locale="ru"
                onlyDate
                :custom-shortcuts="customShortcuts"
                format="YYYY-MM-DD HH:mm"
                formatted="ll"
              >
              </VueCtkDateTimePicker>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              label="Клиент"
              label-for="client-input-1"
              label-class="mf-label"
              :invalid-feedback="getError('client-1-feedback')"
            >
              <b-form-input
                id="client-input-1"
                name="client-input-1"
                v-validate="{ required: true }"
                v-model="modelFullUnlim.p_client_price"
                :state="validateState('client-input-1')"
                aria-describedby="client-1-feedback"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              label="доля СТМ"
              label-for="org-input-1"
              label-class="mf-label"
              :invalid-feedback="getError('org-feedback-1')"
            >
              <b-form-input
                id="org-input-1"
                name="org-input-1"
                v-validate="{ required: true }"
                v-model="modelFullUnlim.p_ctm_price"
                :state="validateState('fullname-input')"
                aria-describedby="org-feedback-1"
              ></b-form-input>

            </b-form-group>
          </b-col>
          <b-col md="3" class="pr-0 button_place">
            <b-button class="tariff-button" @click="sendFullUnlimData">Добавить</b-button>
          </b-col>
        </b-row>

        <hr class="my-1">
      </b-form>
      <b-row align-h="center" class="mt-5">
        <h4>{{billingParamsStatic.label}}</h4>
      </b-row>
      <b-row>
        <b-col md="2">
          <h5 class="text-center">Тариф :</h5>
        </b-col>
        <b-col md="10">
          <div class="center" v-for="tariff in billingParamsStatic.tariff" :key="tariff.label">
            <b-badge :variant="setColor(tariff.type)">{{tariff.label}}</b-badge>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="2">
          <h5 class="text-center">Опции :</h5>
        </b-col>
        <b-col md="10">
          <div class="center" v-for="option in billingParamsStatic.options" :key="option.label">
            <b-badge :variant="setColor(option.type)">{{option.label}}</b-badge>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { validation } from './validation'

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'billing',
  mixins: [validation],
  components: {
    Treeselect,
    VueCtkDateTimePicker
  },
  data () {
    return {
      itemData: null,
      loading: null,
      selectsTariff: [],
      selectsOptions: [],
      modelCustom: {
        p_type_id: null,
        p_start_at: null,
        p_permanent: false,
        p_custom: false,
        p_client_price: null,
        p_ctm_price: null
      },
      modelServiceUnlim: {
        p_service_id: null,
        p_start_at: null,
        p_custom: false,
        p_client_price: null,
        p_ctm_price: null
      },
      modelFullUnlim: {
        p_start_at: null,
        p_client_price: null,
        p_ctm_price: null
      },
      customShortcuts: [
        { key: 'thisWeek', label: 'Эта неделя', value: 'isoWeek' },
        { key: 'thisMonth', label: 'Этот месяц', value: 'month' },
        { key: 'thisYear', label: 'Этот год', value: 'year' }
      ]
    }
  },
  watch: {
    billingDropdowns () {
      this.selectsTariff = this.billingDropdowns.custom_subscription.p_type_id
      this.selectsOptions = this.billingDropdowns.service_unlim.p_service_id
    }
  },
  computed: {
    isIndividualTariff () {
      if (this.modelCustom.p_custom === true) {
        return {
          p_client_price: {
            label: 'Клиент *',
            disabled: false,
            validation: {
              required: true,
              numeric: true
            }
          },
          p_ctm_price: {
            label: 'доля СТМ *',
            disabled: false,
            validation: {
              required: true,
              numeric: true
            }
          }
        }
      } else {
        return {
          p_client_price: {
            label: 'Клиент',
            disabled: true,
            validation: {
              required: false
            }
          },
          p_ctm_price: {
            label: 'доля СТМ',
            disabled: true,
            validation: {
              required: false
            }
          }
        }
      }
    },
    isIndividualService () {
      if (this.modelServiceUnlim.p_custom === true) {
        return {
          p_client_price: {
            label: 'Клиент *',
            disabled: false,
            validation: {
              required: true,
              numeric: true
            }
          },
          p_ctm_price: {
            label: 'доля СТМ *',
            disabled: false,
            validation: {
              required: true,
              numeric: true
            }
          }
        }
      } else {
        return {
          p_client_price: {
            label: 'Клиент',
            disabled: true,
            validation: {
              required: false
            }
          },
          p_ctm_price: {
            label: 'доля СТМ',
            disabled: true,
            validation: {
              required: false
            }
          }
        }
      }
    },
    ...mapState(
      {
        billingParamsStatic: state => state.groupsUsers.billingParamsStatic,
        billingDropdowns: state => state.groupsUsers.billingDropdowns
      }
    )
  },
  methods: {
    modalBilling (data) {
      this.itemData = data
      console.log(data)
      this.$root.$emit('bv::show::modal', 'ModId5', event)
      this.getBillingProfile(this.itemData).then(
        () => {
          this.getBillingDropdowns(this.itemData).then(
            () => {
              this.loading = true
            }
          )
        }
      )
    },
    sendCustomSubscriptionData (event) {
      event.preventDefault()
      this.modelCustom.p_custom = Number(this.modelCustom.p_custom)
      this.createCustomSubscribe(this.modelCustom).then(
        () => {
          this.getBillingProfile(this.itemData)
        }
      )
    },
    sendServiceUnlimData (event) {
      event.preventDefault()
      this.modelServiceUnlim.p_custom = Number(this.modelServiceUnlim.p_custom)
      this.createServiceUnlim(this.modelServiceUnlim).then(
        () => {
          this.getBillingProfile(this.itemData)
        }
      )
    },
    sendFullUnlimData () {
      this.createFullUnlim(this.modelFullUnlim).then(
        () => {
          this.getBillingProfile(this.itemData)
        }
      )
    },
    clearModal () {
      this.loading = false
    },
    setColor (type) {
      if (type === 'dynamic') {
        return 'secondary'
      } else if (type === 'custom') {
        return 'primary'
      } else {
        return 'success'
      }
    },
    ...mapActions('groupsUsers', [
      'getBillingDropdowns',
      'getBillingProfile',
      'createCustomSubscribe',
      'createServiceUnlim',
      'createFullUnlim'
    ])
  }
}
</script>

<style scoped>
  .button_place {
    display: flex;
    align-items: center;
  }

  .tariff-button {
    margin-top: 8px;
  }
</style>
